import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';

const Testimonials = () => {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  const testimonials = [
    {
      name: 'Marie Dubois',
      location: 'Toulouse Centre',
      rating: 5,
      text: 'Intervention rapide et professionnelle pour la réparation de ma baie vitrée. Le technicien était très compétent et le travail impeccable. Je recommande vivement !',
      service: 'Réparation baie vitrée',
      date: 'Il y a 2 semaines',
      avatar: 'https://public.readdy.ai/ai/img_res/6cb0c405865c47b06b3d71d5c660a84f.jpg'
    },
    {
      name: 'Jean-Pierre Martin',
      location: 'Colomiers',
      rating: 5,
      text: 'Excellent service ! Mes fenêtres PVC ont été réparées en moins de 24h. Prix honnête et travail soigné. Merci pour votre professionnalisme.',
      service: 'Réparation fenêtres PVC',
      date: 'Il y a 1 mois',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20french%20man%20client%20happy%20satisfied%20customer%20portrait%20confident%20friendly%20smile%20simple%20clean%20neutral%20background&width=200&height=200&seq=testimonial-002&orientation=squarish'
    },
    {
      name: 'Sophie Lefebvre',
      location: 'Blagnac',
      rating: 5,
      text: 'Dépannage urgent suite à une effraction. L\'équipe est intervenue dans l\'heure et a sécurisé ma fenêtre. Service irréprochable, je me suis sentie en sécurité.',
      service: 'Dépannage urgent',
      date: 'Il y a 3 semaines',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20french%20woman%20client%20grateful%20satisfied%20customer%20portrait%20warm%20reassuring%20smile%20simple%20clean%20neutral%20background&width=200&height=200&seq=testimonial-003&orientation=squarish'
    },
    {
      name: 'Thomas Rousseau',
      location: 'Tournefeuille',
      rating: 5,
      text: 'Rénovation complète de mes fenêtres en bois. Le résultat est magnifique ! L\'artisan a pris le temps de bien faire les choses. Très satisfait du rendu final.',
      service: 'Restauration fenêtres bois',
      date: 'Il y a 2 mois',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20french%20man%20client%20pleased%20satisfied%20customer%20portrait%20genuine%20happy%20smile%20simple%20clean%20neutral%20background&width=200&height=200&seq=testimonial-004&orientation=squarish'
    },
    {
      name: 'Isabelle Moreau',
      location: 'Ramonville',
      rating: 5,
      text: 'Installation de volets roulants électriques parfaite. Devis clair, délais respectés et finitions impeccables. Je recommande sans hésitation !',
      service: 'Installation volets roulants',
      date: 'Il y a 1 semaine',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20french%20woman%20client%20delighted%20satisfied%20customer%20portrait%20bright%20cheerful%20smile%20simple%20clean%20neutral%20background&width=200&height=200&seq=testimonial-005&orientation=squarish'
    },
    {
      name: 'Laurent Petit',
      location: 'Toulouse',
      rating: 5,
      text: 'Remplacement de double vitrage suite à une fissure. Travail rapide et propre. Le technicien a même nettoyé après son passage. Excellent rapport qualité-prix.',
      service: 'Remplacement vitrage',
      date: 'Il y a 3 semaines',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20french%20man%20client%20content%20satisfied%20customer%20portrait%20friendly%20approving%20smile%20simple%20clean%20neutral%20background&width=200&height=200&seq=testimonial-006&orientation=squarish'
    }
  ];

  return (
    <section id="testimonials" ref={ref} className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <div className="inline-flex items-center bg-teal-100 text-teal-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-star-line mr-2"></i>
            Avis Clients
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Ce que disent nos <strong className="text-teal-600">clients</strong>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Plus de 2500 clients satisfaits nous font confiance pour leurs réparations de fenêtres à Toulouse
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start mb-4">
                <div className="w-14 h-14 rounded-full overflow-hidden mr-4 flex-shrink-0">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-gray-900 text-lg">{testimonial.name}</h3>
                  <p className="text-sm text-gray-500 flex items-center">
                    <i className="ri-map-pin-line mr-1 text-xs"></i>
                    {testimonial.location}
                  </p>
                  <div className="flex items-center mt-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-500 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed mb-4">
                "{testimonial.text}"
              </p>

              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <span className="text-sm text-teal-600 font-semibold">
                  {testimonial.service}
                </span>
                <span className="text-xs text-gray-400">
                  {testimonial.date}
                </span>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="text-center mt-12"
        >
          <div className="inline-flex items-center bg-white rounded-2xl shadow-lg p-6 mb-6">
            <div className="flex items-center mr-6">
              <div className="flex items-center text-yellow-500 text-2xl">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <span className="ml-3 text-3xl font-bold text-gray-900">4.9/5</span>
            </div>
            <div className="border-l border-gray-200 pl-6">
              <p className="text-2xl font-bold text-gray-900">2500+</p>
              <p className="text-sm text-gray-600">Avis clients</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
